import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function Blog() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://okayama-doboku.com';
  
  useSEO({
    title: 'ブログ・新着情報 - おかやま土木工事株式会社 | 岡山市・倉敷市の土木工事',
    description: 'おかやま土木工事株式会社のブログ・新着情報。工事情報、安全対策、技術情報など、土木工事に関する最新情報をお届けします。岡山市・倉敷市の土木工事、水道工事、舗装工事の最新ニュース。',
    keywords: 'ブログ,新着情報,工事情報,安全対策,技術情報,岡山市,倉敷市',
    canonical: '/blog',
    ogType: 'website',
    schema: {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "おかやま土木工事株式会社 ブログ",
      "description": "工事情報、安全対策、技術情報など、土木工事に関する最新情報",
      "url": `${siteUrl}/blog`,
      "publisher": {
        "@type": "Organization",
        "name": "おかやま土木工事株式会社"
      }
    }
  });

  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'すべて' },
    { id: 'news', name: 'お知らせ' },
    { id: 'construction', name: '工事情報' },
    { id: 'safety', name: '安全対策' },
    { id: 'technology', name: '技術情報' }
  ];

  const blogPosts = [
    {
      id: 1,
      title: '年末年始休業のお知らせ',
      category: 'news',
      date: '2024-12-15',
      excerpt: '平素より格別のご愛顧を賜り、厚く御礼申し上げます。年末年始の休業期間についてお知らせいたします。',
      image: 'https://public.readdy.ai/ai/img_res/57cbea61a63d6810f0c195cdda79edbb.jpg',
      content: '誠に勝手ながら、下記の期間を年末年始休業とさせていただきます。休業期間：12月29日（金）〜1月3日（水）新年は1月4日（木）より通常営業いたします。'
    },
    {
      id: 2,
      title: '岡山市北区での大型造成工事が完成しました',
      category: 'construction',
      date: '2024-12-10',
      excerpt: '岡山市北区で進めておりました大型造成工事が無事完成いたしました。工期6ヶ月の大規模プロジェクトでした。',
      image: 'https://readdy.ai/api/search-image?query=Completed%20large-scale%20land%20development%20project%20in%20Okayama%2C%20finished%20residential%20site%20preparation%2C%20professional%20Japanese%20construction%20work%2C%20modern%20infrastructure%20development%2C%20clean%20organized%20construction%20site%2C%20bright%20sunny%20day&width=400&height=250&seq=blog2&orientation=landscape',
      content: '総面積5,000㎡の宅地造成工事を無事完成いたしました。地盤改良から排水設備まで、総合的な造成工事を実施。'
    },
    {
      id: 3,
      title: '新しい安全管理システムを導入しました',
      category: 'safety',
      date: '2024-12-05',
      excerpt: '現場の安全性向上のため、最新のデジタル安全管理システムを導入いたしました。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20workers%20using%20modern%20safety%20management%20technology%20in%20Okayama%2C%20digital%20safety%20systems%2C%20professional%20safety%20equipment%2C%20construction%20site%20safety%20protocols%2C%20bright%20daylight%2C%20high%20quality%20safety%20technology&width=400&height=250&seq=blog3&orientation=landscape',
      content: 'IoT技術を活用した安全管理システムにより、リアルタイムでの現場監視と事故防止を実現します。'
    },
    {
      id: 4,
      title: '倉敷市での水道管更新工事を開始',
      category: 'construction',
      date: '2024-11-28',
      excerpt: '倉敷市からの委託により、老朽化した水道管の更新工事を開始いたします。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20water%20pipe%20replacement%20construction%20in%20Kurashiki%20city%2C%20professional%20plumbing%20infrastructure%20work%2C%20modern%20pipe%20installation%20equipment%2C%20municipal%20water%20system%20upgrade%2C%20organized%20construction%20site%2C%20bright%20daylight&width=400&height=250&seq=blog4&orientation=landscape',
      content: '総延長2kmの水道管更新工事。最新の耐震管を使用し、地域の水道インフラの安全性を向上させます。'
    },
    {
      id: 5,
      title: '環境配慮型舗装工法の採用について',
      category: 'technology',
      date: '2024-11-20',
      excerpt: '環境負荷軽減のため、リサイクル材料を使用した舗装工法を積極的に採用しています。',
      image: 'https://readdy.ai/api/search-image?query=Eco-friendly%20road%20paving%20construction%20in%20Okayama%2C%20sustainable%20construction%20materials%2C%20environmental-conscious%20road%20work%2C%20Japanese%20construction%20team%2C%20green%20construction%20technology%2C%20bright%20sunny%20environment&width=400&height=250&seq=blog5&orientation=landscape',
      content: '再生アスファルトの使用により、CO2削減と資源の有効活用を実現。持続可能な社会の実現に貢献します。'
    },
    {
      id: 6,
      title: '冬季工事における安全対策の強化',
      category: 'safety',
      date: '2024-11-15',
      excerpt: '冬季の工事では、凍結や積雪による事故防止のため、特別な安全対策を実施しています。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20workers%20implementing%20winter%20safety%20measures%20in%20Okayama%2C%20cold%20weather%20construction%20safety%2C%20professional%20winter%20work%20protocols%2C%20safety%20equipment%20for%20winter%20construction%2C%20organized%20winter%20construction%20site&width=400&height=250&seq=blog6&orientation=landscape',
      content: '滑り止め対策、防寒具の着用、作業時間の調整など、冬季特有のリスクに対応した安全管理を徹底しています。'
    },
    {
      id: 7,
      title: '新入社員研修を実施しました',
      category: 'news',
      date: '2024-11-10',
      excerpt: '2024年度新入社員を対象とした安全教育研修を実施いたしました。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20company%20new%20employee%20safety%20training%20in%20Okayama%2C%20professional%20training%20session%2C%20construction%20safety%20education%2C%20indoor%20training%20facility%2C%20professional%20learning%20environment%2C%20bright%20lighting&width=400&height=250&seq=blog7&orientation=landscape',
      content: '基本的な安全知識から実践的な技術まで、3日間の集中研修を通じて新入社員のスキルアップを図りました。'
    },
    {
      id: 8,
      title: '最新の重機を導入しました',
      category: 'technology',
      date: '2024-11-01',
      excerpt: '作業効率向上と安全性確保のため、最新型の油圧ショベルを導入いたしました。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20construction%20excavator%20and%20heavy%20machinery%20in%20Okayama%2C%20latest%20construction%20equipment%2C%20professional%20construction%20technology%2C%20clean%20organized%20construction%20site%2C%20bright%20daylight%2C%20high%20quality%20construction%20machinery&width=400&height=250&seq=blog8&orientation=landscape',
      content: 'GPS機能付きの最新型重機により、精密な施工と作業効率の大幅な向上を実現しています。'
    }
  ];

  const filteredPosts = selectedCategory === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getCategoryName = (categoryId: string) => {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.name : '';
  };

  const getCategoryColor = (categoryId: string) => {
    const colors: { [key: string]: string } = {
      news: 'bg-blue-100 text-blue-800',
      construction: 'bg-green-100 text-green-800',
      safety: 'bg-red-100 text-red-800',
      technology: 'bg-purple-100 text-purple-800'
    };
    return colors[categoryId] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative h-96 bg-cover bg-center" style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Japanese%20construction%20company%20blog%20and%20news%20section%2C%20professional%20business%20communication%2C%20modern%20office%20environment%20with%20computers%20and%20documents%2C%20corporate%20information%20sharing%2C%20bright%20professional%20lighting%2C%20high%20quality%20business%20photography&width=1920&height=600&seq=blog_hero&orientation=landscape')`
        }}>
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 h-full flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <div className="text-white text-center">
                <h1 className="text-4xl md:text-5xl font-bold mb-4">ブログ・新着情報</h1>
                <p className="text-xl md:text-2xl">
                  おかやま土木工事の最新情報をお届けします
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 bg-white border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    selectedCategory === category.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-3">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${getCategoryColor(post.category)}`}>
                        {getCategoryName(post.category)}
                      </span>
                      <time className="text-sm text-gray-500">{formatDate(post.date)}</time>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3 leading-relaxed">
                      {post.excerpt}
                    </p>
                    <div className="text-gray-700 text-sm leading-relaxed">
                      {post.content}
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {filteredPosts.length === 0 && (
              <div className="text-center py-12">
                <i className="ri-file-list-line text-6xl text-gray-400 mb-4"></i>
                <p className="text-xl text-gray-500">該当する記事がありません</p>
              </div>
            )}
          </div>
        </section>

        {/* Newsletter Subscription */}
        <section className="py-16 bg-blue-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <strong>最新情報をお届け</strong>
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              工事情報や安全対策、技術情報など、おかやま土木工事の最新情報を
              メールでお届けします。
            </p>
            
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">メール配信登録</h3>
              <form className="space-y-4">
                <div>
                  <input
                    type="email"
                    placeholder="メールアドレスを入力してください"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line mr-2"></i>
                  配信登録する
                </button>
              </form>
              <p className="text-sm text-gray-500 mt-4">
                ※配信停止はいつでも可能です。個人情報は適切に管理いたします。
              </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              <strong>お問い合わせ</strong>
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              工事に関するご質問やご相談がございましたら、
              お気軽にお問い合わせください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:086-012-3456"
                className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center justify-center border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-600 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>
                お問い合わせフォーム
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}